export default __webpack_public_path__ + "static/media/right-shape.9c01abab.png";